import { render, staticRenderFns } from "./EnderecoCollapse.vue?vue&type=template&id=8d9a5ad8&scoped=true&"
import script from "./EnderecoCollapse.vue?vue&type=script&lang=js&"
export * from "./EnderecoCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9a5ad8",
  null
  
)

export default component.exports